import { Navigate, Outlet } from 'react-router-dom-v5-compat';

import { ROLE_LEVELS, useAuthLevel } from '../../hooks/useCurrentUser';

// Gate for the HR (Echipa) routes, mounted INSIDE the v2 Shell so the chrome
// stays. Mirrors TicketsGate: while the role is still hydrating (`undefined`)
// show a loader rather than redirecting (a redirect during hydration bounces
// refreshes); below manager level (Staff/Manager/Admin all qualify), send to the
// dashboard. The nav already hides HR for shop-kiosk accounts, but the routes
// themselves were previously reachable by any logged-in user — this closes that.
export default function HrGate() {
    const level = useAuthLevel();

    if (level === undefined) {
        return (
            <div className="flex h-64 w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
                Se incarca...
            </div>
        );
    }
    if (level < ROLE_LEVELS.MANAGER) return <Navigate to="/v2/dashboard" replace />;
    return <Outlet />;
}
